import { NgModule,CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER,Inject,LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdftemplateComponent } from './pdftemplate.component';
import { TemplateSelectorComponent } from './template-selector.component';
import { ReceiptTemplateComponent } from './reciept-template.component';
import { PdfTemplateRoutingModule } from './pdftemplate-routing.module'
import { PdfComponent } from './pdf.component';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

@NgModule({
    imports:      [ CommonModule, PdfTemplateRoutingModule ],
    declarations: [ PdftemplateComponent,
     TemplateSelectorComponent,
     ReceiptTemplateComponent,
     PdfComponent,
    ],
    bootstrap:    [ PdftemplateComponent ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
  })
  export class PdfModule { }